import React, { ComponentProps, forwardRef, PropsWithChildren, useLayoutEffect } from 'react';
import { BladeProvider, DropdownOverlay, MenuOverlay, useTheme } from '@razorpay/blade/components';
import { bladeTheme } from '@razorpay/blade/tokens';
import useResolvedTheme from 'hooks/useResolvedTheme';

export const SyncBladeWithPageTheme = () => {
  const [theme] = useResolvedTheme();
  const { colorScheme, setColorScheme } = useTheme();
  useLayoutEffect(() => {
    if (colorScheme !== theme) {
      setColorScheme(theme);
    }
  }, [theme, colorScheme, setColorScheme]);
  return null;
};

export const ThemedBladeProvider = ({ children }: PropsWithChildren<{}>) => {
  const [theme] = useResolvedTheme();
  return (
    <BladeProvider themeTokens={bladeTheme} colorScheme={theme}>
      <SyncBladeWithPageTheme />
      {children}
    </BladeProvider>
  );
};

export const TopNavMenuOverlay = forwardRef<HTMLDivElement, ComponentProps<typeof MenuOverlay>>(
  ({ children, ...props }, ref) => (
    <MenuOverlay ref={ref} {...props}>
      <SyncBladeWithPageTheme />
      {children}
    </MenuOverlay>
  ),
);

export const TopNavDropdownOverlay = Object.assign(
  ({ children, ...props }: ComponentProps<typeof DropdownOverlay>) => (
    <DropdownOverlay {...props}>
      <>
        <SyncBladeWithPageTheme />
        {children}
      </>
    </DropdownOverlay>
  ),
  { componentId: (DropdownOverlay as unknown as { componentId: string }).componentId },
);
